import { render, staticRenderFns } from "./ShowcaseItem.vue?vue&type=template&id=6d4f8e84&scoped=true"
import script from "./ShowcaseItem.vue?vue&type=script&lang=js"
export * from "./ShowcaseItem.vue?vue&type=script&lang=js"
import style0 from "./ShowcaseItem.vue?vue&type=style&index=0&id=6d4f8e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4f8e84",
  null
  
)

export default component.exports